"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../../../../common/constants");
const store_1 = require("../../../../context/store");
const common_1 = require("../../../../utils/common");
const react_1 = require("react");
const CalendarHeaderWrapper = (props) => {
    const { children, isMonthView } = props;
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { width, rawWidth, isDark, showWeekNumbers } = store;
    const headerStyle = {
        paddingLeft: isMonthView
            ? showWeekNumbers
                ? 30
                : 0
            : constants_1.CALENDAR_OFFSET_LEFT,
        width: isMonthView && !showWeekNumbers ? rawWidth : width,
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, common_1.parseCssDark)('Kalend__CalendarHeaderCol', isDark), style: headerStyle }, { children: children })));
};
exports.default = CalendarHeaderWrapper;
